import { Injectable } from "@angular/core";
import { BaseService } from "../../core";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { AnotacaoCreateRequest, AnotacaoResponse, AnotacaoUpdateRequest } from "app/shared/models/ei-models";
import { HttpClient } from "@angular/common/http";

@Injectable({ providedIn: 'root' })
export class AnotacaoService extends BaseService {
  private controllerEndpoint = environment.urlEdducaImobApi.concat('api/Anotacao/');

  constructor(private httpClient: HttpClient) {
    super();
  }

  listarPorAula(aulaId: number): Observable<AnotacaoResponse[]> {
    return this.httpClient.get<AnotacaoResponse[]>(
        `${this.controllerEndpoint}Aula/${aulaId}`, {headers: this.getHeader(true)}
    );
  }

  criar(req: AnotacaoCreateRequest): Observable<AnotacaoResponse> {
    return this.httpClient.post<AnotacaoResponse>(
        this.controllerEndpoint, req, {headers: this.getHeader(true)}
    );
  }

  atualizar(id: number, req: AnotacaoUpdateRequest): Observable<AnotacaoResponse> {
    return this.httpClient.put<AnotacaoResponse>(
        `${this.controllerEndpoint}${id}`, req, {headers: this.getHeader(true)}
    );
  }

  remover(id: number): Observable<void> {
    return this.httpClient.delete<void>(
        `${this.controllerEndpoint}${id}`, {headers: this.getHeader(true)}
    );
  }
}